
jQuery( document ).ready( function() {
	let typeSelected;
	let productSelected;
	let daySelected;
	let languageSelect;
	let pages;
	let currentPaged = 1;
	let loadmoreClicked = false;

	jQuery( '#traning-loadmore' ).on( 'click', function( e ) {
		e.preventDefault();
		pages = jQuery( '#traning-loadmore' ).data( 'pages' );
		console.log( pages );
		currentPaged++;
		loadmoreClicked = true;
		sendAjaxRequest();
	} );

	jQuery( '#typeSelect' ).change( function() {
		typeSelected = jQuery( this ).val();
		sendAjaxRequest();
		console.log( typeSelected );
	} );
	jQuery( '#productSelect' ).change( function() {
		productSelected = jQuery( this ).val();
		sendAjaxRequest();
	} );
	jQuery( '#daysSelect' ).change( function() {
		daySelected = jQuery( this ).val();
		sendAjaxRequest();
	} );
	jQuery( '#languageSelect' ).change( function() {
		languageSelect = jQuery( this ).val();
		sendAjaxRequest();
	} );

	function sendAjaxRequest() {
		console.log( 'pakistan' );

		jQuery( '.loader-container' ).show();
		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'training_filter',
				nonce: localVars.nonce,
				typeSelected,
				productSelected,
				daySelected,
				languageSelect,
				currentPaged,

			},
			success( response ) {
				if ( response ) {
					console.log( response.args );
					if ( loadmoreClicked ) {
						jQuery( '#training-post-container' ).append( response.html );
					} else {
						jQuery( '#training-post-container' ).html( response.html );
					}
					if ( currentPaged === pages ) {
						jQuery( '#traning-loadmore' ).hide();
					}
					jQuery( '#training-load-more-container' ).html( response.pagination );
					jQuery( '.loader-container' ).hide();
				}
			},
			error() {
				const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
				jQuery( '#training-post-container' ).html( htmlTag );
				jQuery( '.loader-container' ).hide();
			},
		} );
	}
} );

